/**
 * Modal component for confirming user presence
 * Reduces database queries by pausing polling when users are away
 */
function PresenceConfirmation({ isVisible, onConfirm, onPause }) {
  if (!isVisible) return null

  return (
    <div 
      className="modal fade show d-block" 
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-person-check me-2"></i>
              Are you still here?
            </h5>
          </div>
          <div className="modal-body">
            <p className="mb-3">
              The dashboard has been idle for a while. To reduce server load, 
              we pause data updates when users are away.
            </p>
            <p className="text-muted small mb-0">
              This helps optimize system performance for all users.
            </p>
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onPause}
            >
              <i className="bi bi-pause-circle me-1"></i>
              Pause Updates
            </button>
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={onConfirm}
            >
              <i className="bi bi-play-circle me-1"></i>
              Continue Monitoring
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PresenceConfirmation
